import { Injectable } from '@angular/core';
import {
  APIKeyResponse,
  TagAddRequest,
  TagDeleteRequest,
  TagResponse,
  TagUpdateListRequest,
  TagUpdateRequest,
  TenantAlertRequest,
  TenantAlertResponse,
  TenantAttrRequest,
  TenantAttrResponse,
} from '@entities/tenantSetting';
import { ApiService } from '@services/api.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class TenantSettingService {
  constructor(private api: ApiService) {}

  /**
   * タグ一覧を取得する
   * @returns タグ一覧
   */
  findAll(): Observable<TagResponse[]> {
    const url = '/tags';
    return this.api.get<TagResponse[]>(url);
  }

  /**
   * タグを追加する
   * @param request 追加内容
   */
  add(request: TagAddRequest): Observable<TagResponse> {
    const url = '/tags';
    return this.api.post<TagResponse>(url, request);
  }

  /**
   * タグを更新する
   * @param request 更新内容
   */
  update(request: TagUpdateRequest): Observable<TagResponse> {
    const url = `/tags/${request.tagId}`;
    return this.api.put<TagResponse>(url, request);
  }

  /**
   * タグを一括削除する
   * @param request 削除対象のタグ
   */
  delete(request: TagDeleteRequest[]): Observable<void> {
    const url = `/tags/_delete`;
    return this.api.post<void>(url, request);
  }

  /**
   * テナント属性情報を取得する
   * @returns テナント属性
   */
  findTenantAttr(): Observable<TenantAttrResponse> {
    const url = '/tenant_attrs';
    return this.api.get<TenantAttrResponse>(url);
  }

  /**
   * テナント属性情報を編集する
   * @returns テナント属性
   */
  updateTenantAttr(request: TenantAttrRequest): Observable<TenantAttrResponse> {
    const url = '/tenant_attrs';
    return this.api.post<TenantAttrResponse>(url, request);
  }

  /**
   * テナント属性情報のWebhookの関連要素（Webhook URL, HTTPヘッダー名, API Key値）を削除する
   * @returns テナント属性
   */
  deleteWebhook(request: TenantAttrRequest): Observable<TenantAttrResponse> {
    const url = `/tenant_attrs/_webhook/`;
    return this.api.put<TenantAttrResponse>(url, request);
  }

  /**
   * APIキー情報を追加する
   * @returns APIキー情報
   */
  addApiKey(): Observable<APIKeyResponse> {
    const url = '/tenant_attrs/_apikey';
    return this.api.post<APIKeyResponse>(url, {});
  }

  /**
   * APIキー情報を削除する
   * @returns APIキー情報
   */
  deleteApiKey(): Observable<void> {
    const url = '/tenant_attrs/_apikey';
    return this.api.delete<void>(url, {});
  }

  /**
   * テナント通知情報を取得する
   * @returns テナント通知
   */
  findTenantAlert(): Observable<TenantAlertResponse> {
    const url = '/tenant_attrs/_notification';
    return this.api.get<TenantAlertResponse>(url);
  }

  /**
   * テナント通知情報を更新する
   * @returns テナント通知
   */
  updateTenantAlert(
    request: TenantAlertRequest,
  ): Observable<TenantAlertResponse> {
    const url = '/tenant_attrs/_notification';
    return this.api.post<TenantAlertResponse>(url, request);
  }

  /**
   * タグの通知先メールアドレスを更新する
   * @returns テナント通知
   */
  updateNotifyEmails(request: TagUpdateListRequest): Observable<TagResponse> {
    const url = '/tags/notify_emails/_update';
    return this.api.put<TagResponse>(url, request);
  }
}
